import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Mail, Lock, ArrowLeft } from 'lucide-react';

const AdminLogin: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    // Frontend validation against static credentials
    const expectedEmail = 'aarya@admin.com';
    const expectedPassword = 'aaryasworld';

    if (email !== expectedEmail || password !== expectedPassword) {
      setError('Invalid credentials');
      setLoading(false);
      return;
    }

    const success = await login(email, password);
    setLoading(false);

    if (success) {
      navigate('/admin');
    } else {
      setError('Invalid credentials');
    }
  };

  return (
    <div className="min-h-screen bg-darkbg-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Back Button */}
        <button 
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-fgray-400 hover:text-white mb-8"
        >
          <ArrowLeft className="w-5 h-5" />
          Back to Gallery
        </button>

        {/* Login Card */}
        <div className="bg-darkbg-800 backdrop-blur-sm border border-fgray-700 rounded-3xl p-10 shadow-2xl">
          <h1 className="text-4xl font-black text-center bg-gradient-to-r from-facebook-500 to-facebook-600 bg-clip-text text-transparent mb-8">
            Admin Login
          </h1>
          
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-semibold text-fgray-300 mb-3 flex items-center gap-2">
                <Mail className="w-4 h-4" />
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-4 bg-darkbg-700 border border-fgray-600 rounded-2xl text-white placeholder-fgray-500 focus:border-facebook-500 focus:outline-none focus:ring-2 focus:ring-facebook-500/30 transition-all"
                placeholder="admin@email.com"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-fgray-300 mb-3 flex items-center gap-2">
                <Lock className="w-4 h-4" />
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-4 bg-darkbg-700 border border-fgray-600 rounded-2xl text-white placeholder-fgray-500 focus:border-facebook-500 focus:outline-none focus:ring-2 focus:ring-facebook-500/30 transition-all"
                placeholder="********"
                required
              />
            </div>

            {error && (
              <div className="p-4 bg-red-500/20 border border-red-500/50 rounded-2xl text-red-300 text-sm">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full py-4 px-8 bg-facebook-600 hover:bg-facebook-700 text-white font-bold text-lg rounded-2xl shadow-2xl hover:shadow-facebook-500/25 transition-all duration-300 transform hover:-translate-y-1 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              {loading ? (
                <>
                  <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                  Signing In...
                </>
              ) : (
                'Sign In'
              )}
            </button>
          </form>
        </div>

        {/* <p className="text-center text-fgray-500 mt-6 text-sm">
          Credentials: admin@admin.com / qwerty123
        </p> */}
      </div>
    </div>
  );
};

export default AdminLogin;
